(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reset-checkout-attributes"] && !Shopify.designMode) return;
  try {
    (() => {
    const marker = 'theme:reset-checkout-attributes';
    const preservedAttributes = new Set(['Telefono', 'Dedicatoria']);

    const mark = () => {
      try {
        sessionStorage.setItem(marker, '1');
      } catch {}
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = new URL(form.action, location.origin);

      if (
        event.submitter?.name === 'checkout' ||
        /\/checkout(?:\/|$)/.test(action.pathname)
      ) {
        mark();
      }
    }, true);

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('a[href]');
      if (!link) return;

      const url = new URL(link.href, location.origin);

      if (
        url.origin === location.origin &&
        /\/checkout(?:\/|$)/.test(url.pathname)
      ) {
        mark();
      }
    }, true);

    window.addEventListener('pageshow', async () => {
      try {
        if (sessionStorage.getItem(marker) !== '1') return;

        const root = window.Shopify.routes.root;
        const response = await fetch(`${root}cart.js`, {
          cache: 'no-store'
        });

        if (!response.ok) return;

        const cart = await response.json();
        const attributes = Object.fromEntries(
          Object.keys(cart.attributes || {})
            .filter((key) => !preservedAttributes.has(key))
            .map((key) => [key, ''])
        );

        if (Object.keys(attributes).length === 0) {
          sessionStorage.removeItem(marker);
          return;
        }

        const updated = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes })
        });

        if (!updated.ok) return;

        sessionStorage.removeItem(marker);
        location.reload();
      } catch {}
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
